import { BaseNodePort } from "../../common";
import domShape from "./dom-shape";
export class CirclePort extends BaseNodePort {
    constructor(props) {
        super(props);
        this.domRender = domShape;
    }
}
//# sourceMappingURL=index.js.map